import { NavLink } from 'react-router-dom';
import type { HubTabDefinition } from '@/config/resource-hubs';
import { usePermissions } from '@/shared/hooks/usePermissions';
import { ScrollArea, ScrollBar } from '@/shared/components/ui/scroll-area';
import { cn } from '@/lib/utils';

export type HubTabBarProps = {
  tabs: HubTabDefinition[];
  basePath: string;
};

/** URL-synced horizontal tab bar for Resource Hub layouts. */
export function HubTabBar({ tabs, basePath }: HubTabBarProps) {
  const { canAny } = usePermissions();

  const visibleTabs = tabs.filter(
    (tab) => !tab.requiredPermissions || canAny(tab.requiredPermissions)
  );

  return (
    <ScrollArea className="w-full whitespace-nowrap">
      <nav className="flex gap-1 border-b border-border pb-px">
        {visibleTabs.map((tab) => (
          <NavLink
            key={tab.id}
            to={`${basePath}/${tab.path}`}
            className={({ isActive }) =>
              cn(
                'inline-flex items-center rounded-t-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-b-2 border-primary bg-primary/5 text-primary'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  );
}
